import { eventOutboundLinksClick } from 'lib/services/gtm'
import styles from './Links.module.scss'

export default function Links({ links }) {
  if (!links || links.length === 0) return null

  const doAnalytics = (link) => {
    eventOutboundLinksClick(link)
  }

  return (
    <div className={styles.container}>
      {links.map((link, index) => (
        <>
          <h2 className={styles.title}>{link.title}</h2>
          <a
            className={`btn btn--secondary btn--pink ${styles.button}`}
            key={index}
            href={link.link}
            target="_blank"
            rel="noreferrer"
            onClick={() => doAnalytics(link.link)}
          >
            {link.button_text}
            <img
              src="/img/external_link.svg"
              alt="External link icon"
              className={styles.externalIcon}
            />
          </a>
        </>
      ))}
    </div>
  )
}
